import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import SmallModuleHead from '@src/pc/index/components/SmallModuleHead';
import Chip from 'Chip';
import { getEventDate, getScheduleDate } from '@src/mobile/utils/time';
import { EVENT_STATUS_MAP } from '@src/mobile/constants';

const Schedule = ({ scheduleHead, scheduleData }) => {
    const scheduleList = scheduleData?.results?.list || [];

    return (
        <div className={styles.schedule}>
            <Chip id="260477" type="struct" title="焦点赛程头" content={scheduleHead}>
                <SmallModuleHead />
            </Chip>
            <div className={styles.scheduleBox}>
                {scheduleList.slice(0, 2).map((item, index) => {
                    const { date, time, isEnd, ucmsType, base62Id, url } = item;
                    const { dayType } = getScheduleDate(date);
                    const { formatTime, eventStatus, eventStatusText } = getEventDate({
                        date,
                        time,
                        dayType,
                        isEnd,
                        ucmsType,
                        base62Id,
                        url,
                    });

                    return (
                        <Fragment key={item.id}>
                            <div className={styles.scheduleItem}>
                                <div className={styles.scheduleItemHead}>
                                    <div className={styles.scheduleItemHeadL}>
                                        {item.group}
                                        {item.round}
                                    </div>
                                    <div
                                        onClick={() => {
                                            if (eventStatus !== EVENT_STATUS_MAP.NOT_START && eventStatusText.includes('战报') && url) {
                                                window.open(url);
                                            }
                                        }}
                                        className={`${styles.scheduleItemHeadR} ${
                                            eventStatus === EVENT_STATUS_MAP.REPORT ? styles.report : ''
                                        }`}>

                                        {eventStatus === EVENT_STATUS_MAP.NOT_START ? formatTime : eventStatusText}
                                    </div>
                                </div>
                                <div className={styles.scheduleList}>
                                    <div className={styles.schedulePicBox}>
                                        {item.guojia1icon && (
                                            <img className={styles.schedulePic} src={item.guojia1icon} />
                                        )}
                                    </div>
                                    <div className={styles.scheduleCountry}>{item.guojia1}</div>
                                    <div className={styles.scheduleScore}>{item.guojia1score}</div>
                                </div>
                                <div className={styles.scheduleList}>
                                    <div className={styles.schedulePicBox}>
                                        {item.guojia2icon && (
                                            <img className={styles.schedulePic} src={item.guojia2icon} />
                                        )}
                                    </div>
                                    <div className={styles.scheduleCountry}>{item.guojia2}</div>
                                    <div className={styles.scheduleScore}>{item.guojia2score}</div>
                                </div>
                            </div>
                            {index === 0 && (
                                <div className={styles.scheduleLineBox}>
                                    <div className={styles.scheduleLine} />
                                </div>
                            )}
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

Schedule.propTypes = {
    scheduleHead: PropTypes.object,
    scheduleData: PropTypes.object,
};

export default errorBoundary(Schedule);
